import "./BMXSectionHeader.scss";
const BMXSectionHeader = (props) => {
    const { text } = props;
    return (
        <div className="BMXSectionHeader">
            <div className="line" />
            <span className="title">{text}</span>
        </div>
    );
};

export default BMXSectionHeader;
